import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Tabs } from "jsons/inventory-tabs";
import React, { useEffect, useState } from "react";
import InventoryOptionCardTemplate from "./options/InventoryOptionCardTemplate";
import "scss/_inventory.scss";

export default function InventoryBuilder(props) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [, setInventory] = useState(props.inventory);

  useEffect(() => {
    setInventory(props.inventory);
  }, [props.inventory]);

  return (
    props.num && (
      <div className="strip">
        <TabStrip
          style={{
            backgroundColor: "white",
            margin: "0 15px 0 15px",
            padding: "0px 0px 20px 15px",
            borderTopLeftRadius: "15px",
          }}
          animation={false}
          selected={selectedTab}
          onSelect={(e) => setSelectedTab(e.selected)}
        >
          {Tabs.map((tab) => (
            <TabStripTab title={tab.label} key={tab.key}>
              <InventoryOptionCardTemplate
                num={props.num}
                inventory={props.inventory}
                product={props.product}
                tabOption={tab}
              >
                <tab.component />
              </InventoryOptionCardTemplate>
            </TabStripTab>
          ))}
        </TabStrip>
      </div>
    )
  );
}
